// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --seat-available: #155f82;
  /* --seat-booked: #fd7e14; */
  --seat-mybooked: #4752ba;
}

/* ============================= */
/* LEGEND                        */
/* ============================= */
.seat-legend {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
  margin-bottom: 0;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-icon.available {
  color: #155f82;
  border-color: #155f82;
  background-color: var(--seat-available);
}

.legend-icon.booked {
  color:var(--color-primary-orange);
  border-color: var(--color-primary-orange);
  background-color: var(--color-primary-orange);
}

.legend-icon.mybooked {
  color: var(--seat-mybooked);
  border-color: var(--seat-mybooked);
  background-color: var(--seat-mybooked);
}
.legend-icon.partiallybooked {
  background: linear-gradient(
    135deg,
    var(--color-primary-orange) 50%,
    var(--seat-mybooked) 50%
  );
  border-color: var(--color-primary-orange);
}


/* ============================= */
/* DATE HEADER                   */
/* ============================= */
.seat-date-header {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0;
}

.seat-date {
  color: #2c3e50;
}

/* ============================= */
/* ROOMS ROW                     */
/* ============================= */
.hall-wrapper {
  margin-top: 40px;
  overflow: visible !important;
}

.hall-center-boxes {
  display: flex;
  justify-content: center;
  gap: 40px;
  overflow: visible !important;
}

.hall-box {
  width: 220px;
  height: 350px;
  background: var(--color-white);
  border: 2px solid #cfd8dc;
  position: relative;
  padding-top: 36px;
  box-sizing: border-box;
  overflow: visible !important;
}

.hall-label {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-white);
  background: #28a745;
  border-left: 1px solid #198754;
  border-bottom: 1px solid #198754;
}

/* ============================= */
/* SEATS (CUBICAL)               */
/* ============================= */
.room-seats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: 16px;
  overflow: visible !important;
  /* justify-items: center; */
}

.seat-cube {
  width: 60px;
  height: 90px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.25s ease;
  /* Default border and bg (for safety) */
  border: 2px solid var(--seat-available);
  background-color: var(--color-white);
  color: var(--seat-available);
  margin:0px;
  --tooltip-bg: #ffd9b7;
  --tooltip-text: #000;
  overflow: visible !important;
}

/* Seat states */
.seat-cube.available {
  border-color: var(--seat-available);
  background-color: #155f82;
  color: var(--color-white);
  --tooltip-bg: var(--seat-available);
  --tooltip-text: var(--color-white);
}

.seat-cube.booked {
  border-color: #7f4616;
  background-color: var(--color-primary-orange);
  color: var(--color-white);
  cursor: not-allowed;
  opacity: 0.9;
  --tooltip-bg: var(--color-primary-orange);
  --tooltip-text: var(--color-white);
}

.seat-cube.mybooked {
  border-color: #1e1f48;
  background-color: var(--seat-mybooked);
  color: var(--color-white);
  --tooltip-bg: var(--seat-mybooked);
  --tooltip-text: var(--color-white);
}

/* Hover effects */
.seat-cube.available:hover {
  /* transform: scale(1.12);
  box-shadow: 0 6px 14px rgba(25, 135, 84, 0.35); */
  background: #447f9b;
}

.seat-cube.mybooked:hover {
  /* transform: scale(1.12);
  box-shadow: 0 6px 14px rgba(102, 16, 242, 0.35); */
  background:  var(--seat-mybooked);
}

/* Seat status icon */
.seat-status-icon {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 11px;
  line-height: 1;
}

.seat-cube.booked .seat-status-icon {
  color: var(--color-primary-orange);
}

.seat-cube.mybooked .seat-status-icon {
  color: var(--seat-mybooked);
}

/* ============================= */
/* ROOM LAYOUTS                  */
/* ============================= */

/* Room C → 2 columns, 3 rows */
.room-seats.room-c {
  display: grid;
  grid-template-columns: repeat(2, 60px);
  grid-template-rows: repeat(3, 80px);
  gap: 12px 2px;
  padding: 0;
  justify-content: center;
  align-content: center;
  
}
.room-seats.room-c .seat-cube {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
 
.room-seats.room-d,
.room-seats.room-e {
  display: grid;
  grid-template-columns: 1fr 60px 60px;
  grid-template-rows: 1fr 90px 90px;
  gap: 8px;
  height: 100%;
  padding: 8px;
}
/* RIGHT WALL (vertical stack) */
.room-d .seat-cube:nth-child(1),
.room-e .seat-cube:nth-child(1) {
  grid-column: 2;
  grid-row: 1;
  writing-mode: vertical-rl; 
  justify-self: end;
  transform: translateX(40px);
  z-index: 99;
}

.room-d .seat-cube:nth-child(2),
.room-e .seat-cube:nth-child(2) {
  grid-column: 2;
  grid-row: 2;
  writing-mode: vertical-rl; 
  justify-self: end;
  transform: translateX(40px);
  z-index: 99;
}

.seat-cube.flat {
  writing-mode: horizontal-tb;
  transform: none;
}

/* BOTTOM WALL (side by side) */
.room-d .seat-cube:nth-child(3),
.room-e .seat-cube:nth-child(3) {
  grid-column: 1;
  grid-row: 3;
  writing-mode: horizontal-tb;
  width: 90px;
  height: 60px;
  margin-top: 10px;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
    z-index: 99;

}


.room-d .seat-cube:nth-child(4),
.room-e .seat-cube:nth-child(4) {
  grid-column: 2;
  grid-row: 3;
  writing-mode: horizontal-tb;
  transform: none;
  width: 90px;
  height: 60px;
  justify-self: end;
  transform: translateX(40px);
  margin-top: 10px;
    z-index: 99;

}
/* ============================= */
/* TOOLTIP                        */
/* ============================= */
.seat-tooltip {
  position: absolute;
  bottom: 120%;
  left: 0;
  transform: translateX(-50%);
  background-color: var(--tooltip-bg);
  color: var(--tooltip-text);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 9999;
  writing-mode: horizontal-tb !important; /* Force horizontal */
  text-orientation: mixed;
  text-align: left;
  writing-mode: horizontal-tb !important;
  transform: translateX(-50%) rotate(0deg) !important; 
  min-width: max-content;
}
.seat-tooltip .tooltip-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.seat-tooltip .tooltip-row:not(:last-child) {
  margin-bottom: 2px;
}
.seat-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--tooltip-bg) transparent transparent transparent;
}

.seat-cube:hover .seat-tooltip {
  opacity: 1;
}

/* ============================= */
/* THUMBNAIL                      */
/* ============================= */
.layout-thumbnail {
  position: absolute;
  bottom: 30px;
  right: 30px;
  width: 100px;
  cursor: pointer;
  border: 2px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 10;
}

.layout-thumbnail::before {
  content: '\\1F50D';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  color: #fd7e14;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 1;
  pointer-events: none;
}

.layout-thumbnail img {
  width: 100%;
  display: block;
}
.seat-date-link {
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
}

.seat-date-link:hover {
  opacity: 0.8;
}

.R-C {
  background-color:#F0F7F3 ;
  color:var(--color-primary-green) !important;
}

.R-D {
   background-color:#FFF7EF ;
   color:#B45F13 !important;
}

.R-E {
  background-color:#F1F6FA ;
  color:#1D4D78 !important;
}

.text-muted {
  font-weight: 700;
}
/* ============================= */
/* PARTIALLY BOOKED DIAGONALS     */
/* ============================= */
.seat-cube.partial {
  position: relative;
  color: var(--color-white);
  overflow: visible;

}

/* Morning booked / Evening free */
.seat-cube.partial.morning-booked {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-available) 50%);
}

/* Evening booked / Morning free */
.seat-cube.partial.evening-booked {
  background: linear-gradient(135deg, var(--seat-available) 50%, var(--color-primary-orange) 50%);
}

/* Morning by me / Evening free */
.seat-cube.partial.morning-mybooked {
  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--seat-available) 50%);
}

/* Evening by me / Morning free */
.seat-cube.partial.evening-mybooked {
  background: linear-gradient(135deg, var(--seat-available) 50%, var(--seat-mybooked) 50%);
}


/* Both halves booked by different employees → diagonal split */
.seat-cube.partial.both-booked-morning-me {
  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--color-primary-orange) 50%);
}

/* Both booked: Morning by someone else, Evening by ME */
.seat-cube.partial.both-booked-evening-me {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-mybooked) 50%);
}

/* Both booked by others (neither is me) */
.seat-cube.partial.both-booked-neither {
  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--color-primary-orange) 50%);
}

/* AM/PM Labels */
.seat-cube.partial::before {
  content: "AM";
  position: absolute;
  top: 6px;
  left: 6px;
  font-size: 10px;
  font-weight: 700;
}

.seat-cube.partial::after {
  content: "PM";
  position: absolute;
  bottom: 6px;
  right: 6px;
  font-size: 10px;
  font-weight: 700;
}
/* ============================= */
/* REDUCE STAT TILES HEIGHT      */
/* ============================= */
.statCard {
  min-height: 100px !important;
  height: auto !important;
}

.statCard .card-body {
  padding: 10px 14px !important;
  min-height: auto !important;
}

.statCard .widgets-icons-2 {
  width: 60px !important;
  height: 60px !important;
  font-size: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}

.statCard p {
  font-size: 15px !important;
  margin-bottom: 2px !important;
  line-height: 1.2 !important;
}

.statCard h4 {
  font-size: 20px !important;
  margin: 2px 0 !important;
  line-height: 1.2 !important;
}

/* Make sure Card itself doesn't have excessive padding */
.statCard.card {
  margin-bottom: 0 !important;
}

/* ============================= */
/* DATE PICKER Z-INDEX FIX       */
/* ============================= */
.react-datepicker-popper {
  z-index: 10000 !important;
}

.react-datepicker {
  z-index: 10000 !important;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}
@media (max-width: 768px) {
  .hall-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .hall-center-boxes {
    justify-content: flex-start;
    padding: 0 12px;
  }

  .seat-legend {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    padding-bottom: 4px;
  }
}
@media (max-width: 768px) {
  .hall-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .hall-center-boxes {
    flex-direction: column;   /* rooms stack one below another */
    align-items: center;
    gap: 20px;
    padding: 0 12px;
  }

  .seat-legend {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    padding-bottom: 4px;
  }

  /* Simplify Room D / Room E layout on mobile */
  .room-seats.room-d,
  .room-seats.room-e {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    padding: 12px;
    height: auto;
  }

  .room-d .seat-cube,
  .room-e .seat-cube {
    grid-column: unset;
    grid-row: unset;
    writing-mode: horizontal-tb;
    justify-self: unset;
    transform: none;
    width: 70px;
    height: 70px;
    margin: 0;
  }

  .room-d .seat-cube:nth-child(1),
  .room-e .seat-cube:nth-child(1),
  .room-d .seat-cube:nth-child(2),
  .room-e .seat-cube:nth-child(2),
  .room-d .seat-cube:nth-child(4),
  .room-e .seat-cube:nth-child(4) {
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/seat_booking/components/seatbooking.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE;;;;GAIC;EACD,yCAAyC;AAC3C;;;AAGA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,yBAAyB;EACzB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE;mDACiD;EACjD,mBAAmB;AACrB;;AAEA;EACE;oDACkD;EAClD,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC,+BAA+B;AAC/B;EACE,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,qBAAqB;;AAEvB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;AACA,gCAAgC;AAChC;;EAEE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;EAEE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;IAChB,WAAW;;AAEf;;;AAGA;;EAEE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;IACd,WAAW;;AAEf;AACA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,sCAAsC,EAAE,qBAAqB;EAC7D,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,mDAAmD;EACnD,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;GACG,yBAAyB;GACzB,wBAAwB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;;AAEnB;;AAEA,kCAAkC;AAClC;EACE,+FAA+F;AACjG;;AAEA,kCAAkC;AAClC;EACE,+FAA+F;AACjG;;AAEA,iCAAiC;AACjC;EACE,wFAAwF;AAC1F;;AAEA,iCAAiC;AACjC;EACE,wFAAwF;AAC1F;;;AAGA,+DAA+D;AAC/D;EACE,8FAA8F;AAChG;;AAEA,wDAAwD;AACxD;EACE,8FAA8F;AAChG;;AAEA,0CAA0C;AAC1C;EACE,qGAAqG;AACvG;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB,IAAI,kCAAkC;IAC5D,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,8CAA8C;EAC9C;;IAEE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;;;;;;IAME,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\n  --seat-available: #155f82;\n  /* --seat-booked: #fd7e14; */\n  --seat-mybooked: #4752ba;\n}\n\n/* ============================= */\n/* LEGEND                        */\n/* ============================= */\n.seat-legend {\n  display: flex;\n  gap: 16px;\n  flex-wrap: nowrap;\n  margin-bottom: 0;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.legend-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 2px solid;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.legend-icon.available {\n  color: #155f82;\n  border-color: #155f82;\n  background-color: var(--seat-available);\n}\n\n.legend-icon.booked {\n  color:var(--color-primary-orange);\n  border-color: var(--color-primary-orange);\n  background-color: var(--color-primary-orange);\n}\n\n.legend-icon.mybooked {\n  color: var(--seat-mybooked);\n  border-color: var(--seat-mybooked);\n  background-color: var(--seat-mybooked);\n}\n.legend-icon.partiallybooked {\n  background: linear-gradient(\n    135deg,\n    var(--color-primary-orange) 50%,\n    var(--seat-mybooked) 50%\n  );\n  border-color: var(--color-primary-orange);\n}\n\n\n/* ============================= */\n/* DATE HEADER                   */\n/* ============================= */\n.seat-date-header {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 0;\n}\n\n.seat-date {\n  color: #2c3e50;\n}\n\n/* ============================= */\n/* ROOMS ROW                     */\n/* ============================= */\n.hall-wrapper {\n  margin-top: 40px;\n  overflow: visible !important;\n}\n\n.hall-center-boxes {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  overflow: visible !important;\n}\n\n.hall-box {\n  width: 220px;\n  height: 350px;\n  background: var(--color-white);\n  border: 2px solid #cfd8dc;\n  position: relative;\n  padding-top: 36px;\n  box-sizing: border-box;\n  overflow: visible !important;\n}\n\n.hall-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-white);\n  background: #28a745;\n  border-left: 1px solid #198754;\n  border-bottom: 1px solid #198754;\n}\n\n/* ============================= */\n/* SEATS (CUBICAL)               */\n/* ============================= */\n.room-seats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  padding: 16px;\n  overflow: visible !important;\n  /* justify-items: center; */\n}\n\n.seat-cube {\n  width: 60px;\n  height: 90px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.25s ease;\n  /* Default border and bg (for safety) */\n  border: 2px solid var(--seat-available);\n  background-color: var(--color-white);\n  color: var(--seat-available);\n  margin:0px;\n  --tooltip-bg: #ffd9b7;\n  --tooltip-text: #000;\n  overflow: visible !important;\n}\n\n/* Seat states */\n.seat-cube.available {\n  border-color: var(--seat-available);\n  background-color: #155f82;\n  color: var(--color-white);\n  --tooltip-bg: var(--seat-available);\n  --tooltip-text: var(--color-white);\n}\n\n.seat-cube.booked {\n  border-color: #7f4616;\n  background-color: var(--color-primary-orange);\n  color: var(--color-white);\n  cursor: not-allowed;\n  opacity: 0.9;\n  --tooltip-bg: var(--color-primary-orange);\n  --tooltip-text: var(--color-white);\n}\n\n.seat-cube.mybooked {\n  border-color: #1e1f48;\n  background-color: var(--seat-mybooked);\n  color: var(--color-white);\n  --tooltip-bg: var(--seat-mybooked);\n  --tooltip-text: var(--color-white);\n}\n\n/* Hover effects */\n.seat-cube.available:hover {\n  /* transform: scale(1.12);\n  box-shadow: 0 6px 14px rgba(25, 135, 84, 0.35); */\n  background: #447f9b;\n}\n\n.seat-cube.mybooked:hover {\n  /* transform: scale(1.12);\n  box-shadow: 0 6px 14px rgba(102, 16, 242, 0.35); */\n  background:  var(--seat-mybooked);\n}\n\n/* Seat status icon */\n.seat-status-icon {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.seat-cube.booked .seat-status-icon {\n  color: var(--color-primary-orange);\n}\n\n.seat-cube.mybooked .seat-status-icon {\n  color: var(--seat-mybooked);\n}\n\n/* ============================= */\n/* ROOM LAYOUTS                  */\n/* ============================= */\n\n/* Room C → 2 columns, 3 rows */\n.room-seats.room-c {\n  display: grid;\n  grid-template-columns: repeat(2, 60px);\n  grid-template-rows: repeat(3, 80px);\n  gap: 12px 2px;\n  padding: 0;\n  justify-content: center;\n  align-content: center;\n  \n}\n.room-seats.room-c .seat-cube {\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n}\n \n.room-seats.room-d,\n.room-seats.room-e {\n  display: grid;\n  grid-template-columns: 1fr 60px 60px;\n  grid-template-rows: 1fr 90px 90px;\n  gap: 8px;\n  height: 100%;\n  padding: 8px;\n}\n/* RIGHT WALL (vertical stack) */\n.room-d .seat-cube:nth-child(1),\n.room-e .seat-cube:nth-child(1) {\n  grid-column: 2;\n  grid-row: 1;\n  writing-mode: vertical-rl; \n  justify-self: end;\n  transform: translateX(40px);\n  z-index: 99;\n}\n\n.room-d .seat-cube:nth-child(2),\n.room-e .seat-cube:nth-child(2) {\n  grid-column: 2;\n  grid-row: 2;\n  writing-mode: vertical-rl; \n  justify-self: end;\n  transform: translateX(40px);\n  z-index: 99;\n}\n\n.seat-cube.flat {\n  writing-mode: horizontal-tb;\n  transform: none;\n}\n\n/* BOTTOM WALL (side by side) */\n.room-d .seat-cube:nth-child(3),\n.room-e .seat-cube:nth-child(3) {\n  grid-column: 1;\n  grid-row: 3;\n  writing-mode: horizontal-tb;\n  width: 90px;\n  height: 60px;\n  margin-top: 10px;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n    z-index: 99;\n\n}\n\n\n.room-d .seat-cube:nth-child(4),\n.room-e .seat-cube:nth-child(4) {\n  grid-column: 2;\n  grid-row: 3;\n  writing-mode: horizontal-tb;\n  transform: none;\n  width: 90px;\n  height: 60px;\n  justify-self: end;\n  transform: translateX(40px);\n  margin-top: 10px;\n    z-index: 99;\n\n}\n/* ============================= */\n/* TOOLTIP                        */\n/* ============================= */\n.seat-tooltip {\n  position: absolute;\n  bottom: 120%;\n  left: 0;\n  transform: translateX(-50%);\n  background-color: var(--tooltip-bg);\n  color: var(--tooltip-text);\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  z-index: 9999;\n  writing-mode: horizontal-tb !important; /* Force horizontal */\n  text-orientation: mixed;\n  text-align: left;\n  writing-mode: horizontal-tb !important;\n  transform: translateX(-50%) rotate(0deg) !important; \n  min-width: max-content;\n}\n.seat-tooltip .tooltip-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.seat-tooltip .tooltip-row:not(:last-child) {\n  margin-bottom: 2px;\n}\n.seat-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: var(--tooltip-bg) transparent transparent transparent;\n}\n\n.seat-cube:hover .seat-tooltip {\n  opacity: 1;\n}\n\n/* ============================= */\n/* THUMBNAIL                      */\n/* ============================= */\n.layout-thumbnail {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  width: 100px;\n  cursor: pointer;\n  border: 2px solid #ccc;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  z-index: 10;\n}\n\n.layout-thumbnail::before {\n  content: '\\1F50D';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 32px;\n  color: #fd7e14;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  pointer-events: none;\n}\n\n.layout-thumbnail img {\n  width: 100%;\n  display: block;\n}\n.seat-date-link {\n  cursor: pointer;\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n.seat-date-link:hover {\n  opacity: 0.8;\n}\n\n.R-C {\n  background-color:#F0F7F3 ;\n  color:var(--color-primary-green) !important;\n}\n\n.R-D {\n   background-color:#FFF7EF ;\n   color:#B45F13 !important;\n}\n\n.R-E {\n  background-color:#F1F6FA ;\n  color:#1D4D78 !important;\n}\n\n.text-muted {\n  font-weight: 700;\n}\n/* ============================= */\n/* PARTIALLY BOOKED DIAGONALS     */\n/* ============================= */\n.seat-cube.partial {\n  position: relative;\n  color: var(--color-white);\n  overflow: visible;\n\n}\n\n/* Morning booked / Evening free */\n.seat-cube.partial.morning-booked {\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-available) 50%);\n}\n\n/* Evening booked / Morning free */\n.seat-cube.partial.evening-booked {\n  background: linear-gradient(135deg, var(--seat-available) 50%, var(--color-primary-orange) 50%);\n}\n\n/* Morning by me / Evening free */\n.seat-cube.partial.morning-mybooked {\n  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--seat-available) 50%);\n}\n\n/* Evening by me / Morning free */\n.seat-cube.partial.evening-mybooked {\n  background: linear-gradient(135deg, var(--seat-available) 50%, var(--seat-mybooked) 50%);\n}\n\n\n/* Both halves booked by different employees → diagonal split */\n.seat-cube.partial.both-booked-morning-me {\n  background: linear-gradient(135deg, var(--seat-mybooked) 50%, var(--color-primary-orange) 50%);\n}\n\n/* Both booked: Morning by someone else, Evening by ME */\n.seat-cube.partial.both-booked-evening-me {\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--seat-mybooked) 50%);\n}\n\n/* Both booked by others (neither is me) */\n.seat-cube.partial.both-booked-neither {\n  background: linear-gradient(135deg, var(--color-primary-orange) 50%, var(--color-primary-orange) 50%);\n}\n\n/* AM/PM Labels */\n.seat-cube.partial::before {\n  content: \"AM\";\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.seat-cube.partial::after {\n  content: \"PM\";\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  font-size: 10px;\n  font-weight: 700;\n}\n/* ============================= */\n/* REDUCE STAT TILES HEIGHT      */\n/* ============================= */\n.statCard {\n  min-height: 100px !important;\n  height: auto !important;\n}\n\n.statCard .card-body {\n  padding: 10px 14px !important;\n  min-height: auto !important;\n}\n\n.statCard .widgets-icons-2 {\n  width: 60px !important;\n  height: 60px !important;\n  font-size: 28px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n}\n\n.statCard p {\n  font-size: 15px !important;\n  margin-bottom: 2px !important;\n  line-height: 1.2 !important;\n}\n\n.statCard h4 {\n  font-size: 20px !important;\n  margin: 2px 0 !important;\n  line-height: 1.2 !important;\n}\n\n/* Make sure Card itself doesn't have excessive padding */\n.statCard.card {\n  margin-bottom: 0 !important;\n}\n\n/* ============================= */\n/* DATE PICKER Z-INDEX FIX       */\n/* ============================= */\n.react-datepicker-popper {\n  z-index: 10000 !important;\n}\n\n.react-datepicker {\n  z-index: 10000 !important;\n}\n\n.react-datepicker-popper {\n  z-index: 9999 !important;\n}\n@media (max-width: 768px) {\n  .hall-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .hall-center-boxes {\n    justify-content: flex-start;\n    padding: 0 12px;\n  }\n\n  .seat-legend {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    justify-content: flex-start;\n    padding-bottom: 4px;\n  }\n}\n@media (max-width: 768px) {\n  .hall-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .hall-center-boxes {\n    flex-direction: column;   /* rooms stack one below another */\n    align-items: center;\n    gap: 20px;\n    padding: 0 12px;\n  }\n\n  .seat-legend {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    justify-content: flex-start;\n    padding-bottom: 4px;\n  }\n\n  /* Simplify Room D / Room E layout on mobile */\n  .room-seats.room-d,\n  .room-seats.room-e {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n    padding: 12px;\n    height: auto;\n  }\n\n  .room-d .seat-cube,\n  .room-e .seat-cube {\n    grid-column: unset;\n    grid-row: unset;\n    writing-mode: horizontal-tb;\n    justify-self: unset;\n    transform: none;\n    width: 70px;\n    height: 70px;\n    margin: 0;\n  }\n\n  .room-d .seat-cube:nth-child(1),\n  .room-e .seat-cube:nth-child(1),\n  .room-d .seat-cube:nth-child(2),\n  .room-e .seat-cube:nth-child(2),\n  .room-d .seat-cube:nth-child(4),\n  .room-e .seat-cube:nth-child(4) {\n    transform: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
